import React, { useState, useEffect } from 'react';
import { isMobile } from "react-device-detect";
import { Widget } from "@typeform/embed-react";
import styled from "styled-components";

function Home() {
  const Group = styled.img`
    width: 430px;
    height: auto;
    padding: 7%;
    @media(max-width: 820px){
      width: 50%;
      padding: 0;
      margin-bottom: 30px;
    }
  `;


  if (isMobile) {
    return (
      <div>
        <div className="container-center-horizontal">
          <Widget id="us4uR3Fz" style={{ width: "100%", height: "100%", padding: "50px" }} className="my-form" />;
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <div className="container-center-horizontal">
          <Widget id="us4uR3Fz" style={{ width: "100%", height: "100%", padding: "100px" }} className="my-form" />;
        </div>
      </div>
    );
  }

}

export default Home;
